/** Landing scroll progress [0, 1] — read by Antigravity canvas for parallax / wave boost. */
let landingScrollProgress = 0

export function setLandingScrollProgress(progress: number): void {
  landingScrollProgress = Math.max(0, Math.min(1, progress))
}

export function getLandingScrollProgress(): number {
  return landingScrollProgress
}

export function resetLandingScrollProgress(): void {
  landingScrollProgress = 0
}
